window.$ = window.jQuery = require('jquery');
import setupCmsBanners from "../cms-banners";
import setupMap from "./modules/index/setup-map";
import setupRequestCallback from './forms/modules/request-callback';
import setupSendEnquiry from './forms/modules/send-enquiry';
import setupFindBusinessCentre from '../modules/dealer-locators/find-dealer-search-box';

setupCmsBanners();
setupRequestCallback();
setupSendEnquiry();

$('.get-quote-button').on('click', function() {
    let inst = $('[data-remodal-id="get-quote"]').remodal();
    inst.open();
});

setupFindBusinessCentre(document.getElementById('find-business-centre'));

const whyChooseUs = document.querySelector('.why-choose-us');
if (whyChooseUs) {
    $('.why-choose-us').slick({
        infinite: true,
        swipeToSlide: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 9999,
                settings: 'unslick'
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
    });
}

const vanImages = document.querySelector('.van-images');
if (vanImages) {
    $('.van-images').slick({
        infinite: true,
        swipeToSlide: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
    });
}

$('.business-page__carousel').slick({
    arrows: false,
    dots: true,
    infinite: true
});

setupMap();


// WEBPACK FOOTER //
// ./resources/assets/js/fleet-and-business/index.js